import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";

// External components
import SubscriptionMenusQuantities from "../subscriptionMenusQuantities/subscriptionMenusQuantities";
import CollapsibleContent from "../collapsibleContent/collapsibleContent";
import AvoidTagsFilter from "../avoidTagsFilter/avoidTagsFilter";

// Helpers
import { localCurrency } from "@/plugins/currency";

@Component({
  components: { CollapsibleContent, AvoidTagsFilter, SubscriptionMenusQuantities },
  methods: { localCurrency },
})
export default class OnBoardingSubscriptionSummary extends Vue {
  @Getter getSubscription;
}
